import { render, staticRenderFns } from "./FindPwdForm.vue?vue&type=template&id=65329303&scoped=true&"
import script from "./FindPwdForm.vue?vue&type=script&lang=js&"
export * from "./FindPwdForm.vue?vue&type=script&lang=js&"
import style0 from "./FindPwdForm.vue?vue&type=style&index=0&id=65329303&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65329303",
  null
  
)

export default component.exports